export default "__VITE_ASSET__B4OJ0T4C__"